// ภาพกระดาษพร้อมสิ่งที่ตัวอ่านเห็น — ใช้ทั้งหน้าสแกน PDF และหน้าสแกนด้วยกล้อง
// เขียว = คำตอบที่อ่านได้, ส้ม = ข้อที่ไม่แน่ใจ, วงฟ้า = สี่เหลี่ยมมุมที่ใช้จัดภาพ
import React from 'react'
import { answerLabel } from './examUtils'

export default function SheetOverlay({ thumb, markers, rows, text, objective, uncertain }) {
  const unsure = new Set(uncertain || [])
  const chars = text ? [...text] : []
  const indexOf = new Map(objective.map((q, i) => [q.eq_no, i]))
  return (
    <div className="position-relative" style={{ width: thumb.width, maxWidth: '100%' }}>
      <img src={thumb.url} alt="" className="w-100 d-block border" />
      <svg className="position-absolute top-0 start-0 w-100 h-100" viewBox={`0 0 ${thumb.width} ${thumb.height}`}>
        {markers?.map((m, i) => (
          <circle key={i} cx={m.x * thumb.scale} cy={m.y * thumb.scale} r={6} fill="none" stroke="#0d6efd" strokeWidth="2" />
        ))}
        {rows.map((row) => {
          const chosen = chars[indexOf.get(row.eq_no)]
          return row.bubbles.map((b) => {
            const picked = chosen && answerLabel(b.value) === chosen
            return (
              <circle key={`${row.eq_no}-${b.value}`} cx={b.x * thumb.scale} cy={b.y * thumb.scale}
                r={Math.max(3, b.r * thumb.scale)}
                fill={picked ? 'rgba(25,135,84,.35)' : 'none'}
                stroke={unsure.has(row.eq_no) ? '#fd7e14' : picked ? '#198754' : 'transparent'}
                strokeWidth="2">
                <title>{`ข้อ ${row.eq_no} ${answerLabel(b.value)} ความเข้ม ${b.delta}`}</title>
              </circle>
            )
          })
        })}
      </svg>
    </div>
  )
}

// รายการข้อที่ไม่แน่ใจพร้อมค่าความเข้มของทุกช่อง — ให้ครูตัดสินเองจากตัวเลขประกอบภาพ
export function UncertainList({ uncertain, rows }) {
  if (!uncertain?.length) return null
  return (
    <ul className="fs-sm ps-3">
      {uncertain.map((no) => {
        const row = rows.find((r) => r.eq_no === no)
        return (
          <li key={no}>
            ข้อ {no}: อ่านได้ <b>{row?.answer === '#' ? 'ฝนหลายช่อง' : answerLabel(row?.answer) || 'ไม่ตอบ'}</b>
            <span className="text-secondary"> ({row?.bubbles.map((b) => `${answerLabel(b.value)} ${b.delta}`).join(' · ')})</span>
          </li>
        )
      })}
    </ul>
  )
}
